module.exports = __webpack_public_path__ + "static/media/leverages-artificial-intelligence@3x.29b9caf5.png";